import 'css/mobile/arena.scss';
import 'js/mobile/common/common.jquery.js';